import React from 'react';
import { observer } from 'mobx-react';
import { Table, Divider, Modal, message } from 'antd';
import ComForm from './Form';
import http from 'libs/http';
import store from './store';
import { LinkButton } from "components";

@observer
class ComTable extends React.Component {
  componentDidMount() {
    store.fetchRecords()
  }

  columns = [{
    title: '序号',
    key: 'series',
    render: (_, __, index) => index + 1,
    width: 80,
  }, {
    title: '班级名称',
    dataIndex: 'class_name',
    sorter: (a, b) => a.class_name.length - b.class_name.length
  }, {
    title: '学员名字',
    dataIndex: 'student_name',
    sorter: (a, b) => a.student_name.length - b.student_name.length
  }, {
    title: '周次',
    dataIndex: 'week',
  }, {
    title: '作业链接',
    dataIndex: 'detail',
    width: 300
  },{
    title: '提交时间',
    dataIndex: 'created_at'
  },{
    title: '备注信息',
    dataIndex: 'desc',
    ellipsis: true
  }, {
    title: '操作',
    render: info => (
      <span>
        <LinkButton auth="homework.record.edit" onClick={() => store.showForm(info)}>编辑</LinkButton>
        <Divider type="vertical"/>
        <LinkButton auth="homework.record.del" onClick={() => this.handleDelete(info)}>删除</LinkButton>
      </span>
    )
  }];

  handleDelete = (text) => {
    Modal.confirm({
      title: '删除确认',
      content: `确定要删除【${text['student_name']}】的作业记录?`,
      onOk: () => {
        return http.delete('/api/homework/record', {params: {id: text.id}})
          .then(() => {
            message.success('删除成功');
            store.fetchRecords()
          })
      }
    })
  };

  render() {
    let data = store.records;
    if (store.f_class) {
      data = data.filter(item => item['class_name'].toLowerCase().includes(store.f_class.toLowerCase()))
    }
    return (
      <React.Fragment>
        <Table rowKey="id" loading={store.isFetching} dataSource={data} columns={this.columns}/>
        {store.formVisible && <ComForm/>}
      </React.Fragment>
    )
  }
}

export default ComTable
